export default function WobbleRaceIcon() {
  return (
    <svg viewBox="0 0 64 64" aria-hidden="true">
      <rect x="2" y="2" width="60" height="60" rx="14" fill="#7FD3FF" />
      <rect x="2" y="44" width="60" height="18" rx="0" fill="#FF7CC2" />
      <rect x="2" y="40" width="60" height="6" fill="#FFD34D" />
      <path d="M8 18 L56 30" stroke="#E8384F" strokeWidth="6" strokeLinecap="round" />
      <path d="M8 18 L56 30" stroke="#FFFFFF" strokeWidth="6" strokeDasharray="5 5" />
      <circle cx="32" cy="24" r="5" fill="#5B3FA8" />
      <g transform="translate(22 42)">
        <ellipse cx="-4" cy="-14" rx="3" ry="7" fill="#2F8BFF" stroke="#164787" strokeWidth="1.5" transform="rotate(-12 -4 -14)" />
        <ellipse cx="4" cy="-14" rx="3" ry="7" fill="#2F8BFF" stroke="#164787" strokeWidth="1.5" transform="rotate(12 4 -14)" />
        <circle cx="0" cy="0" r="10" fill="#2F8BFF" />
        <ellipse cx="1" cy="2" rx="5" ry="3.8" fill="#FFF4E8" />
        <circle cx="-2" cy="-3" r="1.3" fill="#20242C" />
        <circle cx="4" cy="-3" r="1.3" fill="#20242C" />
      </g>
      <g transform="translate(46 13)">
        <path d="M0 -10 L2.9 -4 L9.5 -3.1 L4.7 1.5 L5.9 8.1 L0 5 L-5.9 8.1 L-4.7 1.5 L-9.5 -3.1 L-2.9 -4 Z" fill="#FFC93B" stroke="#B98500" strokeWidth="1.5" />
      </g>
      <g transform="translate(44 46) rotate(15)">
        <ellipse cx="-3.5" cy="-12" rx="2.6" ry="6" fill="#FF8A1F" />
        <ellipse cx="3.5" cy="-12" rx="2.6" ry="6" fill="#FF8A1F" />
        <circle cx="0" cy="0" r="9" fill="#FF8A1F" />
        <ellipse cx="1" cy="2" rx="4.5" ry="3.4" fill="#FFF4E8" />
      </g>
    </svg>
  );
}
